import React, { useState, Fragment } from "react";
import ajax from "superagent";
import { OrganizationHeaderContextConsumer } from "./CustomizeLandingPage";
import HeaderBannerCropper from "./HeaderBannerCropper";
import ReactS3Uploader from "react-s3-uploader";

const OrganizationHeader = ({
  editMode,
  bannerUrl,
  croppedBannerURL,
  organizationName,
  embedMode,
  isEventOrganizer,
  desktopScreen
}: {
  editMode: boolean;
  bannerUrl: string | null;
  croppedBannerURL: string | null;
  organizationName: string;
  embedMode: boolean;
  isEventOrganizer: boolean;
  desktopScreen: boolean;
}) => {
  const [imageProcessing, setImageProcessing] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isCropping, setIsCropping] = useState(false);

  const imageSelected = (file: any, next: Function) => {
    setImageProcessing(true);
    next(file);
  };

  const editModeView = () => (
    <OrganizationHeaderContextConsumer>
      {context =>
        context &&
        (bannerUrl ? (
          <Fragment>
            {isCropping ? (
              <HeaderBannerCropper
                bannerURL={bannerUrl}
                coversS3Bucket={context.coversS3Bucket}
                bannerS3BasePath={context.bannerS3BasePath}
                cropFinished={croppedBannerURL => {
                  context.updateCroppedBanner(croppedBannerURL);
                  setIsCropping(false);
                }}
                cancelCrop={() => setIsCropping(false)}
              />
            ) : (
              <div className="top-banner-wrapper">
                <div
                  className="org-upload-section top-banner-container"
                  style={{
                    backgroundImage: `url("${croppedBannerURL || bannerUrl}")`
                  }}
                >
                  <button
                    className="org-banner-remove-btn"
                    onClick={_ => context.updateBanner(null)}
                  >
                    Remove Banner
                  </button>

                  <button
                    className="org-banner-adjust-btn"
                    onClick={e => setIsCropping(true)}
                  >
                    Adjust Banner
                  </button>
                  <div className="org-banner-prev org-banner-adjust-btn ">
                    <i
                      className="fa fa-info-circle fa-cover-size"
                      data-toggle="tooltip"
                      aria-hidden="true"
                    ></i>{" "}
                    Banner only visible in desktop view
                  </div>
                </div>
              </div>
            )}
          </Fragment>
        ) : (
          <div className="container top-header-container org-upload-div-wrapper">
            <div className="org-upload-section">
              <label className="btn btn-primary org-upload-btn">
                {imageProcessing ? progress + "%" : "Upload a banner"}
                <ReactS3Uploader
                  className={"dv-upload-input"}
                  style={{ display: "none" }}
                  getSignedUrl={(file: any, callback: any) => {
                    ajax
                      .get("/s3/signed_url")
                      .query({
                        bucket: context.coversS3Bucket,
                        objectKey: `${context.bannerS3BasePath}/${file.name}`,
                        contentType: file.type
                      })
                      .then(data => {
                        callback(JSON.parse(data.text));
                      })
                      .catch(error => {
                        console.error(error);
                      });
                  }}
                  accept="image/*"
                  preprocess={imageSelected}
                  onProgress={(completedPercent: number) => {
                    setImageProcessing(true);
                    setProgress(completedPercent);
                  }}
                  onError={console.error}
                  onFinish={(result: any) => {
                    setImageProcessing(false);
                    context.updateBanner(result.signedUrl.split("?")[0]);
                  }}
                  uploadRequestHeaders={{
                    "x-amz-acl": "public-read"
                  }}
                  scrubFilename={(filename: string) =>
                    filename.replace(/[^\w\d_\-.]+/gi, "")
                  }
                  contentDisposition="auto"
                />
              </label>
              <p className="org-upload-p1">RECOMMENDED SIZE 2400 x 500PX</p>
              <p className="org-upload-p2">MIN SIZE 1200 X 250PX</p>
              <p className="org-ban-prev">
                Banner only visible in desktop view
              </p>
            </div>
          </div>
        ))
      }
    </OrganizationHeaderContextConsumer>
  );

  if (editMode) return editModeView();
  else
    return (
      <div>
        {bannerUrl && desktopScreen && (
          <div className="top-banner-wrapper">
            <div
              className="top-banner-container"
              style={{
                backgroundImage: `url("${croppedBannerURL || bannerUrl}")`
              }}
            ></div>
          </div>
        )}
        {!embedMode && (
          <div className="container top-header-container">
            <div className="organiser-details">
              {isEventOrganizer && <p>Events organised by</p>}
              <h1>{organizationName}</h1>
            </div>
          </div>
        )}
      </div>
    );
};
export default OrganizationHeader;
